{
  "status": {
    "draft": "Borrador",
    "published": "Publicada",
    "closed": "Cerrada",
    "archived": "Archivada"
  },
  "questionTypes": {
    "text": "Texto corto",
    "textarea": "Texto largo",
    "number": "Número",
    "currency": "Moneda (R$)",
    "select": "Selección única",
    "multiselect": "Opción múltiple",
    "checkbox": "Casilla de verificación",
    "scale": "Escala",
    "nps": "NPS (0-10)",
    "rating": "Valoración (estrellas)"
  },
  "triggerTypes": {
    "general": "General — aparece al entrar en la plataforma",
    "courseCompleted": "Tras completar un curso específico",
    "moduleCompleted": "Tras completar un módulo específico",
    "lessonCompleted": "Tras completar una clase específica",
    "daysAfterSignup": "X días después del registro",
    "daysAfterEnrollment": "X días después de la inscripción",
    "signupPeriod": "Periodo de registro (fecha inicial y final)"
  },
  "triggerConfig": {
    "general": {
      "short": "Aparece para todos los alumnos nada más entrar en la plataforma.",
      "example": "Ej.: Encuesta de satisfacción general para recopilar feedback amplio."
    },
    "courseCompleted": {
      "short": "Se activa cuando el alumno completa el 100% de las clases de un curso específico.",
      "example": "Ej.: Pedir el NPS cuando el alumno termina el curso completo \"JavaScript desde cero\"."
    },
    "lessonCompleted": {
      "short": "Se activa cuando el alumno marca una clase específica como completada.",
      "example": "Ej.: \"¿Cómo valoras esta clase?\" — aparece al final de la clase de bienvenida."
    },
    "moduleCompleted": {
      "short": "Se activa cuando el alumno completa todas las clases de un módulo específico.",
      "example": "Ej.: Pedir una nota NPS después de que el alumno termine el módulo de JavaScript."
    },
    "daysAfterSignup": {
      "short": "Se activa cuando pasan X días desde que el alumno creó la cuenta.",
      "example": "Ej.: \"¿Qué tal está siendo tu experiencia?\" 7 días después del registro."
    },
    "daysAfterEnrollment": {
      "short": "Se activa X días después de que el alumno se inscriba en un curso específico.",
      "example": "Ej.: Pedir una valoración 30 días después de comprar el curso premium."
    },
    "signupPeriod": {
      "short": "Aparece solo para alumnos que se registraron dentro de un periodo específico.",
      "example": "Ej.: Encuesta para el grupo de enero: registros entre el 01/01 y el 31/01."
    }
  },
  "list": {
    "title": "Encuestas",
    "subtitle": "Crea y gestiona encuestas personalizables para tus alumnos",
    "newSurvey": "Nueva encuesta",
    "newSurveyTitle": "Nueva encuesta",
    "stats": {
      "total": "Total",
      "published": "Publicadas",
      "responses": "Respuestas",
      "questions": "Preguntas"
    },
    "tabs": {
      "all": "Todas",
      "draft": "Borrador",
      "published": "Publicadas",
      "closed": "Cerradas"
    },
    "empty": {
      "title": "No se encontró ninguna encuesta",
      "description": "Crea tu primera encuesta para recopilar el feedback de los alumnos",
      "create": "Crear encuesta"
    },
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "publish": "Publicar",
      "close": "Cerrar",
      "delete": "Eliminar"
    },
    "card": {
      "anonymous": "Anónima",
      "questions": "Preguntas",
      "responses": "Respuestas",
      "triggers": "Disparadores",
      "createdAt": "Creada el {{date}}",
      "open": "Abrir →"
    },
    "deleteDialog": {
      "title": "Eliminar encuesta",
      "description": "¿Seguro que quieres eliminar <bold>{{title}}</bold>? Se perderán todas las respuestas.",
      "cancel": "Cancelar",
      "confirm": "Eliminar"
    }
  },
  "edit": {
    "common": {
      "cancel": "Cancelar",
      "save": "Guardar",
      "add": "Añadir"
    },
    "header": {
      "back": "Volver",
      "editTitleHint": "Haz clic para editar el título y la descripción",
      "responsesCount_one": "{{count}} respuesta",
      "responsesCount_zero": "{{count}} respuestas",
      "responsesCount_other": "{{count}} respuestas",
      "questionsCount_one": "{{count}} pregunta",
      "questionsCount_zero": "{{count}} preguntas",
      "questionsCount_other": "{{count}} preguntas",
      "edit": "Editar",
      "previewAsStudent": "Ver como alumno",
      "publish": "Publicar",
      "close": "Cerrar"
    },
    "tabs": {
      "questions": "Preguntas ({{count}})",
      "triggers": "Disparadores ({{count}})",
      "results": "Resultados"
    },
    "questions": {
      "add": "Añadir pregunta",
      "empty": "Aún no hay preguntas. ¡Añade la primera!",
      "section": "Sección: {{section}}",
      "fullPreview": "Vista previa completa — como la verá el alumno",
      "sampleOptionA": "Opción A",
      "sampleOptionB": "Opción B"
    },
    "triggers": {
      "infoTitle": "¿Qué son los disparadores (triggers)?",
      "infoDescription": "Los disparadores definen <bold>cuándo aparece tu encuesta para el alumno</bold>. Sin un disparador, la encuesta queda publicada pero no se muestra a nadie. Con un disparador (ej.: \"tras completar la clase X\"), aparece automáticamente en el momento adecuado y genera respuestas relevantes.",
      "infoMultiple": "Puedes añadir <bold>más de un disparador</bold>: la encuesta aparece en cuanto se active cualquiera de ellos.",
      "configured": "Disparadores configurados ({{count}})",
      "add": "Añadir disparador",
      "emptyTitle": "Ningún disparador configurado",
      "emptyDescription": "Sin disparadores, tu encuesta está publicada pero no aparecerá para los alumnos. Añade el primer disparador a continuación.",
      "addFirst": "Añadir el primer disparador",
      "removed": "Disparador eliminado",
      "days_one": "{{count}} día",
      "days_zero": "{{count}} días",
      "days_other": "{{count}} días"
    },
    "results": {
      "emptyTitle": "Aún no hay respuestas",
      "emptyDescription": "Cuando los alumnos respondan, las métricas, los encuestados y las estadísticas aparecerán aquí.",
      "perQuestion": "Análisis por pregunta",
      "answersCount_one": "{{count}} respuesta",
      "answersCount_zero": "{{count}} respuestas",
      "answersCount_other": "{{count}} respuestas",
      "promoters": "Promotores",
      "neutrals": "Neutros",
      "detractors": "Detractores",
      "average": "media"
    },
    "deleteQuestion": {
      "title": "Eliminar pregunta",
      "description": "¿Eliminar \"{{label}}\"?",
      "confirm": "Eliminar",
      "success": "Pregunta eliminada"
    },
    "questionDialog": {
      "labelRequired": "La pregunta es obligatoria",
      "updated": "Pregunta actualizada",
      "added": "Pregunta añadida",
      "saveError": "Error al guardar la pregunta",
      "editTitle": "Editar pregunta",
      "newTitle": "Nueva pregunta",
      "label": "Pregunta *",
      "labelPlaceholder": "Ej.: ¿Qué te pareció el curso?",
      "type": "Tipo",
      "section": "Sección (opcional)",
      "sectionPlaceholder": "Ej.: Sobre el curso",
      "description": "Descripción (opcional)",
      "descriptionPlaceholder": "Ayuda o contexto para el alumno",
      "placeholder": "Texto de ejemplo",
      "placeholderPlaceholder": "Texto dentro del campo",
      "options": "Opciones (separadas por comas)",
      "optionsPlaceholder": "Opción A, Opción B, Opción C",
      "min": "Mínimo",
      "max": "Máximo",
      "required": "Obligatoria"
    },
    "triggerDialog": {
      "added": "Disparador añadido",
      "addError": "Error al añadir el disparador",
      "title": "Nuevo disparador",
      "description": "Elige cuándo debe aparecer esta encuesta para el alumno.",
      "whenLabel": "¿Cuándo debe aparecer esta encuesta?",
      "selectCourse": "Selecciona el curso",
      "change": "Cambiar",
      "modulesCount_one": "{{count}} módulo",
      "modulesCount_zero": "{{count}} módulos",
      "modulesCount_other": "{{count}} módulos",
      "searchCourse": "Buscar curso...",
      "noCourses": "No se encontró ningún curso",
      "selectModule": "Selecciona el módulo",
      "lessonsCount_one": "{{count}} clase",
      "lessonsCount_zero": "{{count}} clases",
      "lessonsCount_other": "{{count}} clases",
      "noModules": "Este curso no tiene módulos",
      "selectLesson": "Selecciona la clase",
      "noLessons": "Este módulo no tiene clases",
      "daysLabel": "¿Después de cuántos días?",
      "daysHint": "La encuesta se mostrará cuando pase ese número de días.",
      "signupFrom": "Registros a partir del",
      "signupUntil": "Registros hasta el",
      "periodHint": "Solo los alumnos cuya fecha de registro esté dentro de este periodo recibirán la encuesta. Puedes indicar solo una de las fechas.",
      "submit": "Añadir disparador"
    },
    "settings": {
      "titleRequired": "El título es obligatorio",
      "saveError": "Error al guardar",
      "title": "Configuración de la encuesta",
      "description": "Edita el título, la descripción y las opciones de visualización.",
      "titleLabel": "Título *",
      "titlePlaceholder": "Ej.: Encuesta de satisfacción — Curso de JavaScript",
      "descriptionLabel": "Descripción",
      "descriptionPlaceholder": "Explica al alumno el objetivo de la encuesta",
      "descriptionHint": "Aparece justo debajo del título en la pantalla de introducción.",
      "anonymous": "Respuesta anónima",
      "anonymousHint": "No guarda qué alumno envió la respuesta.",
      "allowMultiple": "Respuestas múltiples",
      "allowMultipleHint": "Permite que el mismo alumno responda más de una vez.",
      "xpReward": "XP al responder",
      "xpRewardHint": "Puntos de gamificación que gana el alumno al completar la encuesta.",
      "window": "Periodo de visualización (opcional)",
      "start": "Inicio",
      "end": "Fin",
      "windowPermanent": "<highlight>Encuesta permanente:</highlight> sin inicio ni fin, está disponible mientras siga publicada.",
      "windowUntil": "Disponible <bold>desde ahora hasta</bold> el {{end}}.",
      "windowFrom": "Empieza el <bold>{{start}}</bold> y queda permanente a partir de entonces.",
      "windowRange": "Visible del <bold>{{start}}</bold> al <bold>{{end}}</bold>.",
      "saveChanges": "Guardar cambios"
    },
    "preview": {
      "badge": "Vista previa · Vista del alumno",
      "restart": "Reiniciar",
      "completed": "Completado",
      "step": "Paso {{current}} de {{total}}",
      "yourOpinionMatters": "Tu opinión importa",
      "defaultDescription": "Responde unas preguntas rápidas y ayúdanos a mejorar tu experiencia.",
      "questionsCount_one": "{{count}} pregunta",
      "questionsCount_zero": "{{count}} preguntas",
      "questionsCount_other": "{{count}} preguntas",
      "start": "Empezar ahora",
      "previous": "Anterior",
      "submit": "Enviar respuesta",
      "next": "Siguiente",
      "thanks": "¡Gracias!",
      "success": "Tu respuesta se ha enviado correctamente",
      "xpEarned": "+{{xp}} XP ganados",
      "selectPlaceholder": "Selecciona",
      "npsNotLikely": "Nada probable",
      "npsVeryLikely": "Muy probable"
    },
    "metrics": {
      "total": "Total",
      "totalHint": "Respuestas recibidas",
      "anonymousResponses": "Respuestas anónimas",
      "unique": "Únicos",
      "anonymousHint": "Sin identificación",
      "uniqueHint": "Alumnos distintos",
      "completion": "Finalización",
      "completionHint": "Respuestas finalizadas",
      "period": "Periodo",
      "periodHint": "Primera → última"
    },
    "respondents": {
      "title": "Encuestados ({{count}})",
      "anonymous": "Respuesta anónima",
      "answersAt": "Respuestas · {{date}}",
      "question": "Pregunta",
      "noAnswer": "Sin respuesta"
    }
  }
}
